"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _shared = _interopRequireDefault(require("../_shared"));

// eslint-disable-next-line import/no-anonymous-default-export
var _default = {
  cssVars: "\n    :root {\n      ".concat(_shared["default"], "\n      --sans-serif:\n        Nunito, -apple-system, BlinkMacSystemFont,\n        'avenir next', avenir,\n        helvetica, 'helvetica neue',\n        ubuntu,\n        noto,\n        'segoe ui',\n        arial,\n        sans-serif;\n      --serif: georgia, serif;\n      --code: consolas, monaco, monospace;\n      --black: #000000;\n      --near-black: #1c2833;\n      --navy: #001b44;\n      --dark-blue: #031f73;\n      --pacific-blue: #0093d6;\n      --blue: #3060af;\n      --light-blue: #3455db;\n      --lightest-blue: #417ca5;\n      --alice-blue: #eafaff;\n      --outline-blue: #286fad;\n      --washed-blue: #f2f5f8;\n      --dark-red: #e7040f;\n      --red: #c02f1d;\n      --light-red: #fcdfdc;\n      --orange: #c05717;\n      --dark-orange: #cb4814;\n      --light-orange: #fed4B9;\n      --green: #008575;\n      --light-green: #dff0d8;\n      --gold: #ffb700;\n      --yellow: #fcc300;\n      --light-yellow: #fef5d7;\n      --dark-gray: #707c80;\n      --gray: #c1c7c9;\n      --mid-gray: #dadedf;\n      --light-gray: #f6f6f6;\n      --near-white: #f4f4f4;\n      --white: #ffffff;\n    }\n  "),
  name: 'JustBlinds.com',
  backgroundColor: 'bg-light-gray',
  accordion: {
    accordion: 'ba b--gray',
    animateContentDisplay: true,
    item: {
      content: 'pa3',
      title: {
        base: {
          heading: {
            wrapper: 'f3',
            text: ''
          },
          normal: {
            wrapper: 'bb b--mid-gray',
            text: ''
          }
        },
        collapsed: 'bg-light-gray',
        expanded: 'bg-white',
        collapsedAlternate: 'bg-light-gray',
        expandedAlternate: 'bg-white',
        padding: 'pa3',
        lastItemClosedStyle: 'bn',
        toggle: {
          color: 'black',
          icon: 'MdExpandMore',
          position: 'right',
          css: {
            collapsed: "\n              transform: rotate(0);\n            ",
            expanded: "\n              transform: rotate(180deg);\n            "
          }
        }
      }
    }
  },
  alert: {
    base: 'ba br3 items-start',
    icons: {
      error: {
        color: 'red',
        vector: 'MdErrorOutline'
      },
      success: {
        color: 'green',
        vector: 'MdCheckCircle'
      },
      warning: {
        color: 'yellow',
        vector: 'MdErrorOutline'
      }
    },
    spacing: 'pa2 pa3-ns mb3',
    types: {
      error: 'near-black b--red bg-light-red',
      primary: 'near-black b--pacific-blue bg-alice-blue',
      secondary: 'near-black b--gray bg-light-gray',
      success: 'near-black b--green bg-light-green',
      warning: 'near-black b--yellow bg-light-yellow'
    },
    typography: 'sans-serif f6 f5-ns'
  },
  avatar: {
    color: 'orange',
    size: '200px'
  },
  badges: [],
  banner: {
    background: 'var(--white)',
    border: '1px solid var(--mid-gray)',
    heading: {
      fontWeight: '700',
      fontSize: '3rem',
      lineHeight: '4.25rem',
      paddingBottom: '10px'
    },
    subHeading: {
      fontWeight: '400',
      fontSize: '1rem',
      lineHeight: '22px',
      paddingBottom: '25px'
    },
    anchor: {
      padding: '0 5px',
      textDecoration: 'underline',
      textDecorationLine: 'underline',
      color: 'var(--blue)'
    },
    imageBox: {
      borderColor: 'var(--mid-gray)',
      backgroundColor: 'var(--light-gray)'
    },
    imageBoxDragAccept: {
      borderColor: 'var(--green)'
    },
    imageBoxDragReject: {
      borderColor: 'var(--red)'
    },
    imageBoxFocused: {
      borderColor: 'var(--blue)'
    }
  },
  breadcrumbs: {
    delimiter: '‹',
    fontSize: 'f5',
    linkColor: 'green',
    maxWidth: '1240px',
    isVisible: false
  },
  brightcoveplayer: 'NFnZhnSNG',
  button: {
    base: 'ttu br2',
    hoverBackgroundColor: 'rgba(0, 0, 0, 0.15)',
    scaleOnHover: false,
    sizes: {
      normal: 'ph4 pv3 f5',
      small: 'ph3 pv2 f6'
    },
    disabled: {
      appearance: 'b--gray bg-gray',
      text: 'white',
      outline: {
        appearance: 'b--gray bg-transparent',
        text: 'gray'
      }
    },
    primary: {
      appearance: 'bg-green b--green',
      text: 'white',
      outline: {
        appearance: 'bg-transparent b--green hover-bg-green hover-white',
        text: 'green'
      },
      overrides: ''
    },
    secondary: {
      appearance: 'bg-dark-gray white b--dark-gray',
      text: 'white',
      outline: {
        appearance: 'bg-transparent b--dark-gray',
        text: 'dark-gray'
      }
    },
    tertiary: {
      appearance: 'bg-red b--red',
      text: 'white',
      outline: {
        appearance: 'bg-transparent b--red',
        text: 'red'
      }
    },
    alert: {
      appearance: 'bg-red b--red',
      text: 'white underline',
      outline: {
        appearance: 'bg-transparent b--red',
        text: 'red'
      }
    }
  },
  table: {
    headerCell: 'fw5',
    size: {
      normal: {
        cellSize: 'pa2',
        headerCellSize: 'pa2'
      },
      large: {
        cellSize: 'pa3',
        headerCellSize: 'pa3'
      }
    },
    type: {
      standard: {
        cell: {
          tachyons: 'bt b--mid-gray',
          css: ''
        },
        row: {},
        rowBgColor: 'bg-white'
      },
      stripes: {
        cell: {
          tachyons: '',
          css: ''
        },
        row: {},
        rowBgColor: 'bg-light-gray'
      }
    },
    typography: 'sans-serif f5'
  },
  checkbox: {
    checkboxBorderColor: 'mid-gray',
    checkboxBorderRadius: '5px',
    checkboxBorderWidth: '1px',
    checkboxColorChecked: 'green',
    checkboxColorDisabled: 'mid-gray',
    checkboxColorHover: 'mid-gray',
    checkboxSize: '22px',
    checkmarkColor: 'white',
    checkmarkPosition: 'left: 8px; top: 4px; width: 5px; height: 10px;',
    fontSize: '16px',
    textColorDisabled: 'gray',
    textLeftOffset: '2rem',
    textTopOffset: '3px'
  },
  configurator: {
    enablePayPal: false,
    showExternalPromoMessage: false,
    draftBanner: {
      logoName: 'jb-logo'
    },
    global: "\n      [data-id=\"pcp\"] {\n        max-width: 1240px;\n      }\n    ",
    choice: {
      border: 'bw2 br3',
      maxWidth: 'mw4'
    },
    choiceContainer: {
      borderRadius: '6px',
      boxShadow: '0px 0px 10px 0px #1c28331a',
      borderWidth: '2px',
      display: 'flex',
      justifyContent: 'space-between',
      padding: '4px',
      paddingLeft: '5px',
      paddingBottom: '10px',
      zoomImage: {
        tachyons: "right-0",
        css: ""
      }
    },
    option: {
      base: 'relative-ns br3-ns bn ba-ns bw2-ns flex-shrink-0',
      dictionaryTermBackgroundColor: 'bg-green',
      dictionaryTermColor: 'near-black',
      dictionaryTermIconColor: 'green',
      image: 'br2',
      selectedIcon: 'light-blue',
      selectedText: 'near-black',
      selectedLabel: 'near-black',
      sizeGroup: 'flex-wrap flex-nowrap-ns',
      showDivider: true,
      title: {
        base: 'f3 fw7 pt3 pr3 ttc',
        border: ''
      }
    },
    price: {
      addsPrice: 'black',
      text: 'red'
    },
    productInfo: {
      price: {
        dimensions: false
      }
    },
    promo: 'green',
    size: {
      showHelpText: true
    },
    ctaLabelsAlignments: 'justify-between',
    summary: {
      background: 'bg-washed-blue',
      border: 'none',
      choiceValue: 'black',
      floatingBar: {
        background: 'bg-navy',
        priceColor: 'white'
      },
      stickyTop: '1rem',
      tableType: 'stripes'
    }
  },
  pip: {
    preview: {
      container: {
        maxWidth: 'max-width: 350px;'
      },
      samples: {
        tachyons: 'dn db-ns'
      },
      selectedSwatch: '',
      selectedSwatchTy: 'bb b--gray ',
      selectedSwatchInfo: 'pl3',
      styledInfo: 'ph3 ph4-l pb4-l',
      priceAndPromo: ''
    },
    productSpecifications: {
      adobeDownloadDisabled: []
    },
    productSummary: {
      howToGetIt: {
        variant: 'dynamic',
        "static": {
          color: 'var(--near-black)'
        }
      },
      howToGetItBorder: {
        border: 'none'
      },
      dimensionDropdowns: {
        showLabelValues: false
      },
      productInstallationCtaViewDisable: false,
      ctaHide: {
        display: 'none'
      }
    },
    productOptions: {
      showSampleOrderAlert: {
        display: 'block'
      }
    },
    productGallery: {
      internetNumLabel: 'Internet #'
    }
  },
  contentBox: {
    appearance: 'bg-white',
    content: 'f5',
    expandArrowColor: 'green',
    title: 'f5 bb b--mid-gray'
  },
  dropdown: {
    arrowColor: 'near-black',
    arrowColorDisabled: 'gray',
    arrowVector: 'caret',
    borderBottomWidth: '2px',
    borderColor: 'b--mid-gray',
    borderErrorColor: 'b--mid-gray',
    borderWidth: '2px',
    borderRadius: 'br2',
    disabledLabel: 'near-black',
    focusBorderColor: 'green',
    fontWeight: 400,
    label: 'sans-serif'
  },
  formComponents: {
    fontSize: {
      input: '16px',
      label: '16px'
    },
    inputDropdownHeight: {
      normal: '42px',
      small: '37px'
    }
  },
  globalStyles: '',
  heading: {
    primary: {
      container: null,
      text: 'fw7'
    },
    secondary: {
      container: '',
      text: 'bb b--green'
    },
    font: {
      tachyons: {
        h1: 'f1',
        h2: 'f2',
        h3: 'f3',
        h4: 'f4',
        h5: 'f5',
        h6: 'f6',
        h7: 'f7'
      },
      manual: {}
    }
  },
  internalUser: {
    showEmptyCartLink: true
  },
  leadGeneration: {
    getStarted: {
      accountIcon: {
        color: 'var(--white)',
        size: '3em'
      },
      checkIcon: {
        color: 'var(--green)',
        size: '2em'
      },
      clockIcon: {
        color: 'var(--white)',
        size: '2.25em'
      },
      phoneIcon: {
        color: 'var(--orange)',
        size: '1.75em'
      }
    },
    highlighted: 'fw7 tc w-100 orange',
    howItWorks: {
      list: {
        style: "\n          content: counter(index, decimal);\n          counter-increment: index;\n          background-color: var(--orange);\n          color: var(--white);\n          display: inline-block;\n          position: absolute;\n          height: 1.75em;\n          width: 1.75em;\n          text-align: center;\n          vertical-align: middle;\n          line-height: 1.75em;\n          border-radius: 5em;",
        vertical: "left: 0;",
        horizontal: "top: -2.5em;"
      }
    },
    verifyAddress: {
      style: 'w-100 bg-light-blue',
      locationIcon: {
        color: 'blue',
        size: '1.25em'
      }
    }
  },
  link: {
    types: {
      anchor: {
        "default": 'underline red',
        hover: ''
      },
      'high-visibility': {
        "default": 'b black',
        hover: 'underline',
        icon: {
          code: 'MdChevronRight',
          color: 'green',
          position: 'after'
        }
      },
      standard: {
        "default": 'underline red',
        hover: ''
      },
      remove: {
        "default": 'black no-underline b',
        hover: 'underline',
        icon: {
          code: 'MdClose',
          color: 'red',
          position: 'before'
        }
      }
    }
  },
  modal: {
    settings: {
      footer: false
    },
    borderRadius: 'br2',
    boxShadowCss: '',
    closeButton: 'hover-bg-light-gray green',
    content: {
      appearance: 'pb3 ph3',
      withTitle: 'pa3'
    },
    header: {
      appearance: 'pa2',
      withTitle: 'bb b--mid-gray'
    },
    overlayColorRgba: 'rgba(0,0,0,.7)',
    title: 'fw5 f5 h2-ns ml2 pr2'
  },
  newsletterSignUp: {
    _settings: {
      defaultMode: 'light'
    },
    buttonColor: 'primary',
    content: {
      cta: 'Subscribe',
      prefix: 'Don&apos;t miss out on sales, tips, and new products.',
      suffix: 'Opt-out at anytime. View privacy policy [here](/privacy)',
      titleLine1: 'Sign up & Save $20',
      titleLine2: 'on orders of $200 or greater.'
    },
    color: {
      dark: {
        text: 'white'
      },
      light: {
        text: 'near-black'
      }
    },
    design: {
      container: 'w-100 ph2 mw6 tc center',
      title: 'f4'
    }
  },
  orangePay: {
    cssStylesOverrides: "\n      .flex-container {\n        font-family: Nunito, Arial, Helvetica, sans-serif;\n        padding: 0;\n        background-color: #F6F6F6;\n      }\n      div.form-controls{\n        background-color: #FFFFFF;\n      }\n      @media screen and (max-width: 375px) {\n        .flex-container .cc-expdate-cvv-wrapper {\n          display: block;\n        }\n        .form-input__security-code {\n          margin: 20px 0px;\n          width: 100%;\n        }\n      }\n      .form-input__field {\n        border: 2px solid #DADEDF;\n        border-radius: 4px;\n      }\n      .form-input__field:focus {\n        border-color: #00A895;\n        border-width: 2px;\n      }\n      .form-input--error .form-input__field {\n        border: 2px solid #DADEDF;\n        border-radius: 6px;\n        background-image: none;\n        background-color: white;\n        background-position: calc(100% - 10px) 50%;\n        background-repeat: no-repeat;\n        margin-bottom: 0px;\n      }\n      .form-input__label {\n        margin-bottom: 5px;\n      }\n      .form-input__label::after {\n        margin-left: 2px;\n        content: \"*\";\n        color: #C02F1D;\n      }\n      .form-input__security-code input {\n        margin-top: 5px;\n      }\n      .form-input__security-code label span:before {\n        margin-left: 2px;\n        font-size: 160%;\n        color: #C02F1D;\n        content: \"*\";\n      }\n      .form-input--error .form-input-error__message {\n        font-size: 14px;\n        color: #C02F1D;\n      }\n      .form-input.form-input__cc {\n        margin-bottom: 15px;\n      }\n      .form-input.form-input__cc img {\n        top: 34px;\n      }\n      .form-input__security-code img {\n        top: 34px;\n      }\n      .form-input__security-code .small-font{\n        font-size: 16px;\n      }\n      #security-code-input .form-controls{\n        margin-top: 5px;\n      }\n      .form-input__label .small-font{\n        font-size: 16px;\n      }\n      .form-input__security-code label span:before {\n        font-size: 16px;\n        color: #C02F1D;\n      }\n      .drop-down__title {\n        border: 2px solid #DADEDF;\n        border-radius: 6px;\n      }\n      .drop-down__title.drop-down__title--select:focus-within {\n        border-color: #00A895;\n        border-radius: 6px;\n      }\n      .drop-down__title.drop-down__title--error {\n        border: 2px solid #DADEDF;\n        border-radius: 6px;\n      }\n      .drop-down__label {\n        padding-bottom: 5px;\n      }\n      .drop-down__label::after {\n        margin-left: 2px;\n        content: \"*\";\n        color: #C02F1D;\n      }\n      .drop-down__title:before {\n        content: \"\";\n      }\n      .drop-down__title:after {\n        background-color: transparent;\n        background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48px' height='48px'%3E%3Cpath fill='%23a2a2a2' d='M14.83,16.42L24,25.59l9.17-9.17L36,19.25l-12,12l-12-12L14.83,16.42z'/%3E%3C/svg%3E\");\n        background-position: right 40%;\n        background-repeat: no-repeat;\n      }\n      .expiration-date .drop-down-error__message{\n        font-size: 14px;\n        margin-top: 0px;\n        color: #C02F1D;\n      }\n    ",
    borderWidth: '0px',
    formPaddingBottom: '2rem',
    formPaddingTop: '2rem',
    formMarginBottom: '0px',
    titleVisibility: 'visible'
  },
  price: {
    color: 'red',
    currency: '$',
    displayOrder: {
      prefix: 1,
      price: 4,
      promo: 2,
      suffix: 6,
      promoDesc: 7,
      promoSavings: 3,
      stackable: 5
    },
    prefix: 'ttu dark-red',
    promo: 'flex w-100',
    savingsColor: 'green',
    strikethroughColor: 'gray',
    suffix: '',
    superscriptCents: true,
    superscriptCurrency: false,
    showCentsDelimiter: true,
    priceFontSizeSmall: 'f3'
  },
  quantity: {
    backgroundColor: 'bg-white',
    borderColor: 'b--mid-gray',
    borderRadius: 'br3',
    borderWeight: '',
    componentType: ''
  },
  radioButton: {
    radioButtonBackgroundColor: 'white',
    radioButtonBackgroundColorChecked: 'green',
    radioButtonBorderColor: 'mid-gray',
    radioButtonBorderColorChecked: 'green',
    radioButtonBorderWidth: '1px',
    radioButtonColorChecked: 'white',
    radioButtonColorDisabled: 'mid-gray',
    radioButtonColorHover: 'mid-gray',
    radioButtonSize: '20px',
    radioButtonColor: 'white',
    textColorDisabled: 'gray',
    textLeftOffset: '2rem',
    textTopOffset: '3px'
  },
  rightRailFlyout: {
    enabled: false,
    squareWidth: 55
  },
  selectionBox: {
    choiceSelectionBox: false,
    imageSelectionBox: false,
    borderColor: 'light-gray',
    borderColorSelected: 'green',
    borderRadius: 'br3',
    borderWidth: 'bw1',
    checked: {
      base: 'br-pill white absolute z-1',
      container: '',
      overrides: "\n        width: 30px;\n        height: 30px;\n        top: -0.5rem;\n        right: -0.5rem;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 1.2rem;\n        border: 3px solid var(--white);\n      "
    }
  },
  spinner: {
    color: 'green'
  },
  tag: {
    borderRadius: '.25rem',
    primary: {
      appearance: 'b--gold bg-gold',
      text: 'near-black'
    },
    secondary: {
      appearance: 'b--light-gray bg-light-gray',
      text: 'near-black'
    }
  },
  textInput: {
    backgroundColor: 'bg-white',
    borderColor: 'b--mid-gray',
    borderColorFocus: 'b--green',
    errorColor: 'mid-gray',
    borderRadius: 'br2',
    borderWidth: '2px',
    disabledBackground: 'mid-gray',
    disabledLabel: 'near-black sans-serif',
    disabledText: 'dark-gray',
    errorMessageFontSize: '14px',
    label: 'near-black sans-serif',
    showErrorIcon: false
  },
  textInputButton: {
    borderColor: 'b--mid-gray',
    borderRadius: 'br2',
    borderWidth: '2px',
    fontSize: 'f4'
  },
  toggleSwitch: {
    checked: 'var(--green)',
    unchecked: 'var(--gray)'
  },
  visualizer: {
    _settings: null,
    design: {
      fixedTopPosition: {
        large: '1rem',
        medium: '9rem',
        small: '9rem'
      },
      zoomOut: null
    }
  }
};
exports["default"] = _default;